import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_URL from '../../config/api';

const LineSelection = ({ onSelect }) => {
  const [lines, setLines] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLines();
  }, []);

  const fetchLines = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/production-lines/`);
      const activeLines = (response.data.results || response.data).filter(line => line.is_active);
      setLines(activeLines);
      setLoading(false);
    } catch (error) {
      console.error('Erreur:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="text-center">
          <div className="loading-spinner h-12 w-12 mx-auto mb-4"></div>
          <p className="text-gray-600 font-medium">Chargement des chaînes...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto animate-fade-in">
      <div className="text-center mb-8 sm:mb-12">
        <h2 className="text-3xl sm:text-4xl font-bold text-corporate-900 mb-3">
          Sélectionnez la chaîne de production
        </h2>
        <p className="text-gray-600 text-sm sm:text-base">Choisissez votre chaîne de travail</p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-7 gap-4 sm:gap-6">
        {lines.map((line, index) => (
          <button
            key={line.id}
            onClick={() => onSelect(line)}
            className="card-hover p-6 sm:p-8 min-h-[160px] sm:min-h-[180px] flex flex-col items-center justify-center 
                     animate-fade-in"
            style={{ animationDelay: `${index * 0.05}s` }}
          >
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-gradient-primary rounded-xl flex items-center justify-center mb-3 sm:mb-4 shadow-corporate">
              <svg className="w-8 h-8 sm:w-10 sm:h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
              </svg>
            </div>
            <div className="text-base sm:text-lg font-bold text-corporate-900 text-center mb-1">
              {line.name}
            </div>
            {line.code && (
              <div className="text-xs sm:text-sm text-gray-500 font-medium">
                {line.code}
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LineSelection;
